module.exports = __webpack_public_path__ + "img/add-friend.c8b607f8.svg";